import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})

export class BreadcrumbsComponent implements OnInit {

  breadcrumbs: any;

  constructor() { }

  ngOnInit() {
    this.breadcrumbs = [{ url: 'bestpractice', name: 'Dashboard' }, { url: 'home', name: 'Home' }, { url: 'assessements', name: 'Assessments' }];
  }

}
